import React, { useState, useEffect } from "react";
import { createStockage } from "src/service/stockageApi";

export const AddBoxDialog = ({ addBox, setAddBox }) => {
  const [open, setOpen] = useState(false);
  const [boxName, setBoxName] = useState("");
  const [boxPostData, setBoxPostData] = useState([]);
  const [cat, setCat] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreateCategories = (e) => {
    setCat(e.target.checked);
  };

  useEffect(() => {
    setBoxPostData({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      boxName: boxName,
      motherBox: true,
    });
  }, [boxName]);

  const handleAddBox = async () => {
    handleClose();
    try {
      const response = await createStockage(boxPostData);
      setAddBox(response.id);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <button
        onClick={handleClickOpen}
        className="px-4 py-2 border border-[#1b9faa] text-[#1b9faa] rounded-md hover:bg-[#1b9faa] hover:text-white transition-colors"
      >
        Nouvelle Boite
      </button>

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[400px] p-6">
            <h2 className="text-xl font-semibold mb-4">Ajouter une Boite</h2>
            
            <div className="mb-4">
              <p className="text-gray-600 mb-4">
                Pour ajouter une boite, veuillez entrer le nom de la boite.
              </p>
              
              <input
                type="text"
                placeholder="Nom de la boite"
                value={boxName}
                onChange={(e) => setBoxName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                autoFocus
              />
            </div>

            <div className="flex justify-end space-x-2">
              <button
                onClick={handleClose}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={handleAddBox}
                className="px-4 py-2 bg-[#1b9faa] text-white rounded-md hover:bg-[#15808a]"
              >
                Créer la boite
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
